<template>
  <div class="container">
    <div class="row error-page">
      <h2>{{ $t('message.somethingIsWrong') }} !</h2>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "GeneralError",
  mounted: function() {
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"])
  }
};
</script>
